import { render, staticRenderFns } from "./NavQuickLinks.vue?vue&type=template&id=0b886046"
import script from "./NavQuickLinks.vue?vue&type=script&lang=js"
export * from "./NavQuickLinks.vue?vue&type=script&lang=js"
import style0 from "./NavQuickLinks.vue?vue&type=style&index=0&id=0b886046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
